<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="headline">
      <div>
        <span>{{ $tc('label.evidencias', 1)}}</span>
        <v-tooltip bottom v-if="habilitarUpload">
          <template v-slot:activator="{ on }">
            <v-btn class="ma-0" style="margin-top: -4px !important;" icon v-on="on" @click.stop="$refs.uploadArquivo.open()">
              <v-icon>attach_file</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('title.upload_evidencia') }}</span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <list-files
        @ListFiles_ITENS_ALTERADOS="itensAlterados"
        :habilitar-exclusao="habilitarUpload"
        ref="listFiles"
        :uri="uri"
        v-if="acao.idApuracao"></list-files>
    </v-expansion-panel-content>
    <upload-file-form
      v-if="habilitarUpload"
      ref="uploadArquivo"
      :title="$t('label.upload_evidencia')"
      :url="uriUpload"
      :auto-process-queue="false"
      @UPLOADFILE_SENDING="enviandoArquivo"
      @UPLOADFILE_FILE_ADDED="preencherDescricaoComNomeArquivo"
      @UploadArquivo__success="uploadSucesso">
      <v-text-field
        v-model="descricaoArquivo"
        :rules="[rules.required]"
        :counter="150"
        maxlength="150"
        :label="`${$t('label.descricao')}*`"
        required
      ></v-text-field>
    </upload-file-form>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateComputed } from '@/produto/common/functions/roles-computed-generator';
import basePath from '@/produto/common/functions/api-resource';
import ListFiles from '@/produto/shared-components/files/ListFiles';
import UploadFileForm from '@/produto/shared-components/upload/UploadFileForm';

export default {
  name: 'ApuracaoAcaoArquivos',
  props: {
    acao: Object,
    indHabilitaEvidenciaStatusAprovado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      esperar: false,
      descricaoArquivo: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  components: {
    UploadFileForm,
    ListFiles,
  },
  computed: {
    ...generateComputed('APU_ACAO', [
      'canEdit',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    uri() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.acao.idAcao}/apuracao/${this.acao.idApuracao}`;
    },
    uriUpload() {
      const urlUpload = basePath('job', 'arquivo/acao');
      return `${urlUpload}/${this.acao.idAcao}/apuracao/${this.acao.idApuracao}/upload`;
    },
    indAcaoFDC() {
      const isAcaoFDCNivel2 = this.acao && (this.acao.tipo_acao && this.acao.tipo_acao.includes('FDC'));
      const isAcaoFDCNivel3 = this.acao && (this.acao.tipoAcao && this.acao.tipoAcao.includes('FDC'));

      const isAcaoFDC = (isAcaoFDCNivel2 || isAcaoFDCNivel3);

      return isAcaoFDC;
    },
    habilitarUpload() {
      return (this.canEdit || this.possuiAcessoClienteParaUpload())
        && (this.acao.statusApuracao === 'APURACAO_PREVIA' || this.acao.statusApuracao === 'AGUARDANDO_APURACAO'
          || this.acao.statusApuracao === 'EM_ANALISE' || this.indHabilitaEvidenciaStatusAprovado || (this.indAcaoFDC && this.acao.statusApuracao === 'VENCIDO'));
    },
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      formData.append('descricao', encodeURI(this.descricaoArquivo));
    },
    itensAlterados(payload) {
      this.$emit('ApuracaoAcaoArquivos_itensAlterados', payload);
    },
    possuiAcessoClienteParaUpload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'CLIENTE_APU_ACAO_CRUD').length;
    },
    preencherDescricaoComNomeArquivo(file) {
      this.descricaoArquivo = file.name;
    },
    uploadSucesso() {
      if (this.$refs.listFiles) {
        setTimeout(() => this.$refs.listFiles.refresh(), 1E3);
      }
      this.$toast(this.$t('label.upload_arquivo_sucesso'));
      this.$emit('ApuracaoAcaoArquivos_uploadSucesso');
    },
    arquivoRemovido() {
      if (this.$refs.listFiles.files.length === 1) {
        this.$emit('ApuracaoAcaoArquivos_arquivosRemovidos');
      }
    },
  },
  watch: {
    acao() {
      if (this.$refs.listFiles) {
        if (!this.esperar) {
          this.esperar = true;
          setTimeout(() => {
            if (this.$refs.listFiles) {
              this.$refs.listFiles.refresh();
            }
            this.esperar = false;
          }, 2E2);
        }
      }
    },
  },
};
</script>
